import EventEmitter from "../event-emitter";

export default class SubmitButton {
    constructor(props = {}) {
        this.props = props;
        this.$root = this.props.$root;

        this.animated = this.props.animated == null ? true : this.props.animated;
        this.subscriptions = this.props.subscriptions || [];
        this.eventEmitter = new EventEmitter(this.subscriptions);

        this.SUBMIT_START_EVENT = 'submitStart';

        this.init();
    }

    init() {
        this.$root.addEventListener('click', (e) => {
            e.preventDefault();
            this.eventEmitter.dispatch(this.SUBMIT_START_EVENT);
        });
    }

    setDisabled(disabled = true) {
        this.$root.disabled = disabled;
    }

    animate() {
        if (!this.animated) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            this.$root.classList.add('-animate');
            this.$root.insertAdjacentHTML('beforeend', this.getSpinnerTemplate());
            setTimeout(resolve, 1500);
        });
    }

    endAnimation() {
        if (!this.animated) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            const $spinner = this.$root.querySelector('.f-submit-spinner');
            if ($spinner) {
                $spinner.remove();
            }
            this.$root.insertAdjacentHTML('beforeend', this.getReadyIconTemplate());
            setTimeout(() => {
                const $readyIcon = this.$root.querySelector('.f-submit-ready');
                if ($readyIcon) {
                    $readyIcon.remove();
                }
                this.$root.classList.remove('-animate');
                resolve();
            }, 1000);
        });
    }

    interruptAnimation() {
        if (!this.animated) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            const $spinner = this.$root.querySelector('.f-submit-spinner');
            if ($spinner) {
                $spinner.remove();
            }
            this.$root.classList.remove('-animate');
            resolve();
        });
    }

    getSpinnerTemplate() {
        return `
            <svg class="f-submit-spinner" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity=".1" cx="16" cy="16" r="14" stroke="#4ED401" stroke-width="3"/><path d="M30 16c0-7.732-6.268-14-14-14S2 8.268 2 16" stroke="#4ED401" stroke-width="3"/></svg>
        `;
    }

    getReadyIconTemplate() {
        return `
            <svg class="f-submit-ready" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm-2.31-8.379l11.87-11.87-2.12-2.122-9.75 9.75-4.44-4.44-2.12 2.122 6.56 6.56z" fill="#4ED401"/></svg>
        `;
    }
}